import styles from "./SenhaAlterada.module.css";
import Filler from "../../assets/Filler.jpeg";
import Logo from "../../assets/LogoPrincipal.png";
import {useTranslation} from "react-i18next";


export default function SenhaAlterada(): JSX.Element {
  const {t} = useTranslation();

  return(
    <div className={styles.body}>

      <div className={styles.container}>
        <img src={Logo} className={styles.Logo}/>


            <div className={styles.alterada}>
                <p>{t('alterada.alterada')}</p>
            </div>

            <div className={styles.voltar}>
                <a href="/">{t('alterada.voltar')}</a>
            </div>


    </div>

      <img src={Filler} className={styles.filler}/>
    </div>
  );
}